module.exports = __webpack_public_path__ + "step2.e1138f03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step2.jpg
// module id = zY6z
// module chunks = 0